import { render } from "./VoterList.vue?vue&type=template&id=43bf78b9&scoped=true"
import script from "./VoterList.vue?vue&type=script&lang=ts"
export * from "./VoterList.vue?vue&type=script&lang=ts"

import "./VoterList.vue?vue&type=style&index=0&id=43bf78b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43bf78b9"

export default script